export enum EActionName {
    SPIN = 'spin',
    GAMBLE = 'gamble',
    TAKE = 'take',
    AUTHENTICATE = 'authenticate',
    BONUS_BUY_SPIN = 'bonusbuy_spin'
}
